const SwatchCarousel = {
  parts: [
    'container',
    'containerInner',
    'headerSection',
    'mainHeading',
    'rightColumn',
    'description',
    'ctaButton',
    'swatchContainer',
    'swatchWrap',
    'swatchImage',
    'swatchText',
    'fabricName',
    'swatchName'
  ],
  baseStyle: {
    container: {
      bg: 'brandColors.primaryBG',
      overflow: 'hidden',
    },
    containerInner: {
      display: 'flex',
      py: {base: 15, md: 30},
      px: {base: 0, md: 0},
      flexDirection: 'column',
      alignItems: 'center',
      gap: {base: 10, md: 17.5},
      alignSelf: 'stretch',
    },
    headerSection: {
      display: 'flex',
      px: {base: 5, md: 20},
      alignItems: 'flex-start',
      gap: {base: 4, md: 10},
      alignSelf: 'stretch',
      flexDirection: {base: 'column', md: 'row'},
      maxWidth: '1440px',
      mx: 'auto',
    },
    mainHeading: {
      alignSelf: 'stretch',
      color: 'brandColors.greyscale90',
      fontFamily: 'heading',
      fontSize: {base: '28px', md: '40px'},
      fontWeight: 'medium',
      lineHeight: '120%',
      letterSpacing: {base: '-0.28px', md: '-0.4px'},
      flex: {base: 'none', md: '1 0 0'},
      mb: 0,
    },
    rightColumn: {
      display: 'flex',
      width: {base: 'full', md: 'calc(50% - 20px)'},
      minW: {base: 'auto', md: 'calc(50% - 20px)'},
      pt: {base: 0, md: 2},
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'flex-start',
      gap: 6,
      flexShrink: 0,
    },
    description: {
      alignSelf: 'stretch',
      color: 'brandColors.greyscale90',
      fontFamily: 'body',
      fontSize: {base: 'md', md: 'lg'},
      fontWeight: 'normal',
      lineHeight: '160%',
    },
    ctaButton: {
      display: 'flex',
      height: {base: '54px', md: '54px'},
      py: {base: '14px', md: '14px'},
      px: 12,
      justifyContent: 'center',
      alignItems: 'center',
      gap: 1.5,
      borderRadius: 'base',
      border: '1px solid',
      borderColor: 'brandColors.greyscale',
      bg: 'transparent',
      color: 'brandColors.greyscale',
      fontFamily: 'body',
      fontSize: 'sm',
      fontWeight: 'semibold',
      lineHeight: '120%',
      cursor: 'pointer',
      transition: 'all 0.2s ease',
      _hover: {
        bg: 'brandColors.greyscale',
        color: 'white',
      },
    },
    swatchContainer: {
      display: 'flex',
      alignItems: 'flex-start',
      alignSelf: 'stretch',
      overflow: 'hidden',
      sx: {
        '.swiper': {
          overflow: 'visible',
          width: 'full',
        },
        '.swiper-slide': {
          width: 'auto',
        },
      },
    },
    swatchWrap: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      gap: 3,
      flexShrink: 0,
    },
    swatchImage: {
      width: 'full',
      height: {base: '180px', md: '300px'},
      objectFit: 'cover',
      aspectRatio: 'auto',
    },
    swatchText: {
      display: 'flex',
      px: 2,
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'flex-start',
      gap: 1,
      alignSelf: 'stretch',
    },
    fabricName: {
      color: 'brandColors.greyscale90',
      fontFamily: 'body',
      fontSize: {base: 'sm', md: 'md'},
      fontWeight: 'normal',
      lineHeight: '120%',
    },
    swatchName: {
      color: 'brandColors.greyscale90',
      fontFamily: 'body',
      fontSize: {base: 'sm', md: 'md'},
      fontWeight: 'semibold',
      lineHeight: '120%',
    },
  },
};

export default SwatchCarousel;
